import { Box } from "@mui/material";
import React from "react";
import { PlanoTypography } from "../../../Common";

const PlanoTabsCard = ({ data }) => {
  return (
    <Box
      sx={{
        border: "2px solid lightgrey",
        borderRadius: "8px",
        padding: 1,
        marginTop: 2,
      }}
    >
      <PlanoTypography
        css={{
          fontSize: "16px",
          fontWeight: "500",
          lineHeight: "24px",
          letterSpacing: "0.15000000596046448px",
        }}
      >
        {data.item_desc}
      </PlanoTypography>

      <Box
        display={"flex"}
        gap={2}
        sx={{
          fontSize: "16px",
          fontWeight: "500",
          lineHeight: "24px",
          letterSpacing: "0.15000000596046448px",
        }}
        mt={2}
      >
        <Box bgcolor={"#FBCEB1"} borderRadius={6} p={1} color={"black"}>
          {data.bay_number}
        </Box>
        <Box bgcolor={"#FBCEB1"} borderRadius={6} p={1} color={"black"}>
          Shelf {data.shelf_number}
        </Box>
        <Box bgcolor={"#FBCEB1"} borderRadius={6} p={1} color={"black"}>
          Shelf Position {data.shelf_position}
        </Box>
      </Box>
    </Box>
  );
};

export default PlanoTabsCard;
